export default "/profile/images/instruction-4-en.webp?34c8b50581eda13bd37ac540c647e35e";